import {
  accountPreferencesFields,
  mediaPointFields,
  recordingSettingsFields,
} from '../query-fields';
import { gql } from 'graphql-tag';

export const searchMediaPointsQuery = gql`
  query searchMediaPoints($input: SearchMediaPointsInput!) {
    searchMediaPoints(input: $input) {
      totalCount
      mediaPoints {
        ${mediaPointFields}
      }
    }
  }
`;

export const servicesWithMediaPointsQuery = gql`
  query servicesWithMediaPoints {
    servicesWithMediaPoints {
      services {
        id
        type
        name
      }
    }
  }
`;

export const availableServicesAndAppUsersForMediaPointsQuery = gql`
  query availableServicesAndAppUsersForMediaPoints {
    availableServicesAndAppUsersForMediaPoints {
      services {
        id
        type
        name
      }
      appUsers {
        id
        name
      }
    }
  }
`;

export const mediaPointRecordingEnabledAtSourceQuery = gql`
  query mediaPointRecordingEnabledAtSource($id: ID!) {
    mediaPointRecordingEnabledAtSource(id: $id) {
      status
      errorMessage
    }
  }
`;

export const setMediaPointRecordingSettingsMutation = gql`
  mutation setMediaPointRecordingSettings($input: MediaPointRecordingSettingsInput!) {
    setMediaPointRecordingSettings(input: $input) {
      ${recordingSettingsFields}
    }
  }
`;

export const updateMediaPointMutation = gql`
  mutation updateMediaPoint($input: UpdateMediaPointInput!) {
    updateMediaPoint(input: $input) {
      id
      name
    }
  }
`;

export const accountRecordingPreferencesQuery = gql`
  query accountRecordingPreferences($input: AccountRecordingPreferencesInput!) {
    accountRecordingPreferences(input: $input) {
      ${accountPreferencesFields}
    }
  }
`;

export const updateAccountRecordingPreferencesMutation = gql`
  mutation updateAccountRecordingPreferences($input: UpdateAccountRecordingPreferencesInput!) {
    updateAccountRecordingPreferences(input: $input) {
      ${accountPreferencesFields}
    }
  }
`;

export const getIamMediaPointQuery = gql`
  query getMediaPoint($input: GetMediaPointInput!) {
    getMediaPoint(input: $input) {
      ${mediaPointFields}
    }
  }
`;

export const createIamMediaPointsMutation = gql`
  mutation createMediaPoints($input: CreateMediaPointsInput!) {
    createMediaPoints(input: $input) {
      ${mediaPointFields}
    }
  }
`;
